/*
 * @Author: Teemo Ding
 * @Date: 2021-04-15 15:54:06
 * @LastEditTime: 2021-04-23 17:35:46
 * @LastEditors: Teemo Ding
 * @Description: Image width checkBox
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/CheckImage/index.tsx
 */
import React from 'react';

import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { Checkbox } from 'src/components/Antd';
import DraggableImageDisplay from 'src/components/DragRowDisplay/Image';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.less';

// import _ from 'lodash';
interface IProps {
  title: string | JSX.Element;
  subtitle: string;
  onDelete?: (e) => void;
  onCheckboxChange: (checked) => void;
  imgOnChange: (img) => void;
  linkImage: any;
  checked: boolean;
  imageErrorArray: string[];
  disabled?: boolean;
  hideEdit?: boolean;
}

const CheckImage = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    title,
    subtitle,
    onDelete,
    onCheckboxChange,
    imgOnChange,
    linkImage,
    checked,
    imageErrorArray,
    disabled,
    hideEdit,
    //To Do Delete Link Temp
  } = props;

  return (
    <div className={css.container}>
      <Section className={css.section}>
        <DraggableImageDisplay
          title={title}
          error={imageErrorArray.join(' ')}
          subtitle={subtitle}
          onDelete={onDelete}
          imgOnChange={imgOnChange}
          linkImage={linkImage}
          disabled={disabled}
          hideEdit={hideEdit}
        />

        <div className={css.linkContainer}>
          <Checkbox
            checked={checked}
            disabled={disabled}
            onChange={onCheckboxChange}
          />
          {getI18n('general.setascoverimage')}
        </div>
      </Section>
    </div>
  );
};

export default CheckImage;
